import { Dayjs } from "dayjs"
import {
  IEmailRecipient,
  IEmailVolume,
} from "@/models/admin/emailVolume/emailVolume.types"
import { emailTemplateCatalogueUrl } from "./emailTemplateCatalogueMap"

export class EmailVolume implements IEmailVolume {
  constructor(
    public id: number,
    public status: string,
    public subject: string,
    public processedAt: Dayjs,
    public recipientId: number | null,
    public communicationName: string | null,
    public recipient: IEmailRecipient | null,
  ) {}

  get processedAtDisplay(): string {
    return this.processedAt.format("DD MMM YYYY, h:mm A")
  }

  get templateDisplay(): string {
    return this.communicationName ?? "—"
  }

  get templateCatalogueUrl(): string | null {
    return emailTemplateCatalogueUrl(this.communicationName)
  }
}
